export default "__VITE_ASSET__CP4rtuRp__"